import React, { useEffect, useCallback, useState} from 'react';
import {isNumber} from "utils/IsNumber.js";
import WarpButton from "components/WarpButton.js";
import {connect} from 'react-redux';

const SampleTempo = ({track, sampler}) => { 
    let [editing, setEditing] = useState(false);
    let [tempo, setTempo] = useState(sampler.tempo || "0");

    useEffect(() => {
        setTempo(sampler.tempo || "0");
    }, [setTempo, sampler]);

    const onKeyDown = useCallback((e) => {
        if (e.key === "Enter") {
            setEditing(false);
            sampler.tempo = parseFloat(tempo);
        }
    }, [tempo, setEditing, sampler]);

    useEffect(() => {
        if (tempo !== "" && !isNumber(tempo)) {
            setTempo("");
        }
    }, [tempo, setTempo]);

    return (
        <div className="sample-tempo">
          <WarpButton track={track}/>
          <span
            onClick={() => setEditing(true)}
            className="label">
            BPM
          </span>
          {editing ? <input
                       onKeyDown={onKeyDown}
                       className="tempo-input" onChange={e => setTempo(e.target.value)} value={tempo}/> : 
           <span
             onClick={() => setEditing(true)}
             className="tempo">{tempo === null ? '' : tempo}</span>}
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SampleTempo);
